<div class="relative inline-flex">
  <button
    type="button"
    class="relative inline-flex h-9 w-9 items-center justify-center rounded-full text-secondary-light transition hover:bg-primary-light hover:text-primary"
    aria-label="Notificaciones"
    (click)="toggle()"
  >
    <fa-icon [icon]="faBell"></fa-icon>
    @if (unreadCount() > 0) {
      <span class="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-white">
        {{ unreadCount() > 9 ? '9+' : unreadCount() }}
      </span>
    }
  </button>

  @if (isOpen()) {
    <div class="absolute right-0 top-11 z-50 w-80 rounded-2xl border border-gray-100 bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-gray-100 px-4 py-3">
        <p class="text-sm font-bold text-secondary">Notificaciones</p>
        @if (unreadCount() > 0) {
          <button type="button" class="text-xs font-semibold text-primary hover:underline" (click)="markAllRead()">
            Marcar todas como leídas
          </button>
        }
      </div>

      <div class="max-h-96 overflow-y-auto">
        @if (notifications().length === 0) {
          <p class="px-4 py-6 text-center text-sm text-secondary-light">No tienes notificaciones.</p>
        }
        @for (notification of notifications(); track notification.id) {
          <button
            type="button"
            class="flex w-full flex-col gap-1 border-b border-gray-50 px-4 py-3 text-left transition hover:bg-gray-50"
            [class.bg-primary-light]="!notification.read_at"
            (click)="onNotificationClick(notification)"
          >
            <div class="flex items-center gap-2">
              @if (!notification.read_at) {
                <span class="h-2 w-2 shrink-0 rounded-full bg-primary"></span>
              }
              <p class="text-sm font-semibold text-secondary">{{ notification.data.title }}</p>
            </div>
            <p class="text-xs text-secondary-light">{{ notification.data.message }}</p>
            <p class="text-[11px] text-gray-400">{{ notification.created_at | date: 'dd/MM/yyyy HH:mm' }}</p>
          </button>
        }
      </div>

      <div class="border-t border-gray-100 px-4 py-3 text-center">
        <button type="button" class="text-xs font-semibold text-primary hover:underline" (click)="goToAll()">
          Ver todas las notificaciones
        </button>
      </div>
    </div>
  }
</div>
